import React from 'react';
import { cn } from '../utils/cn';

function LoadingSpinner({ size = 'md', label }) {
  return (
    <div className="state">
      <span className={cn('spinner', size === 'lg' && 'lg')} />
      {label && <div className="muted">{label}</div>}
    </div>
  );
}

export default LoadingSpinner;
